import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const LocalFlashFluidFiles = React.lazy(async () => ({
    default: (await import('@oc/flash-fluid-files/module')).LocalFlashFluidFilesModule
}))

export function LocalFlashFluidFilesComponent() {
    return <SuspenseWhileLoading LazyComponent={LocalFlashFluidFiles} />
}
